import Vue from "vue";
import formPv5OpenEvent from "./components/form-pv5-open-event.vue";
import store from "./store";
import "./assets/main.scss";
import axios from 'axios';
import VueAxios from 'vue-axios';
import Vuelidate from 'vuelidate';
import { email } from "vuelidate/lib/validators";

Vue.use(VueAxios, axios);
Vue.config.productionTip = false;
Vue.use(Vuelidate);

// Registrera pv5-open-event-formuläret i ModalManager
if (window.modalManager) {
    window.modalManager.registerFormType('pv5-open-event', {
        Vue: Vue,
        formComponent: formPv5OpenEvent,
        store: store
    });
}

/**
 * Global function to create and mount a pv5-open-event form app
 * Now uses ModalManager for centralized form handling
 * @param {string} selector - CSS selector for the target DOM element
 * @param {Object} props - Optional props to override element attributes
 * @returns {Vue|undefined} The mounted Vue instance, or undefined on error
 * @global
 */
window.createApp_pv5OpenEvent = function(selector, props = {}) {
    if (!window.modalManager) {
        console.error('ModalManager not available for createApp_pv5OpenEvent');
        return;
    }

    // Registrera pv5-open-event-formuläret om det inte redan är registrerat
    if (!window.modalManager.isFormTypeRegistered('pv5-open-event')) {
        window.modalManager.registerFormType('pv5-open-event', {
            Vue: Vue,
            formComponent: formPv5OpenEvent,
            store: store
        });
    }

    return window.modalManager.createFormApp('pv5-open-event', selector, props);
};

/**
 * Automatically initializes all pv5-open-event forms found in the DOM
 * Now uses ModalManager for centralized form handling
 * @returns {boolean} True if forms were found and processed, false if no forms exist
 */
let renderPv5OpenEventForms = function() {
    // Early exit if no forms exist on page
    const forms = document.querySelectorAll('.form-pv5-open-event');
    if (forms.length === 0) {
        return false;
    }

    if (!window.modalManager) {
        console.error('ModalManager not available for renderPv5OpenEventForms');
        return false;
    }

    // Registrera pv5-open-event-formuläret i ModalManager om det inte redan är registrerat
    if (!window.modalManager.isFormTypeRegistered || !window.modalManager.isFormTypeRegistered('pv5-open-event')) {
        window.modalManager.registerFormType('pv5-open-event', {
            Vue: Vue,
            formComponent: formPv5OpenEvent,
            store: store
        });
    }

    forms.forEach((form, index) => {
        try {
            const parentBlock = form.closest('.nitea-form-selector');

            if (parentBlock) {
                // Inbäddade block initieras av form-selector/view.js (undvik dubbel mount)
                return;
            }


                // Footer/manual context: Force modal mode by setting display mode to modal
                if (!form.id) {

                    form.id = `form-pv5-open-event-footer-${Date.now()}-${index}`;

                }

                window.modalManager.createFormApp('pv5-open-event', `#${form.id}`, {
                    displayMode: 'modal'
                });
        } catch (error) {
            console.error(`Failed to initialize pv5-open-event form ${index}:`, error);
        }
    });

    return true;
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderPv5OpenEventForms);
} else {
    renderPv5OpenEventForms();
}


/**
 * Expose renderPv5OpenEventForms globally for debugging and manual re-initialization
 * @global
 */
window.renderPv5OpenEventForms = renderPv5OpenEventForms;
